export const defaultCalculationRule = 'base_rate + commission + spread';

export const calculationRuleOptions = [
    {
        label: 'Базовый курс',
        value: 'base_rate',
    },
    {
        label: 'Базовый курс + комиссия',
        value: 'base_rate + commission',
    },
    {
        label: 'Базовый курс - комиссия',
        value: 'base_rate - commission',
    },
    {
        label: 'Базовый курс + спред',
        value: 'base_rate + spread',
    },
    {
        label: 'Базовый курс - спред',
        value: 'base_rate - spread',
    },
    {
        label: 'Базовый курс + комиссия + спред',
        value: 'base_rate + commission + spread',
    },
    {
        label: 'Базовый курс + комиссия - спред',
        value: 'base_rate + commission - spread',
    },
    {
        label: 'Базовый курс - комиссия + спред',
        value: 'base_rate - commission + spread',
    },
    {
        label: 'Базовый курс - комиссия - спред',
        value: 'base_rate - commission - spread',
    },
];

const calculationRuleValues = new Set(calculationRuleOptions.map(({ value }) => value));
const calculationRuleOperands = ['commission', 'spread'];

export const normalizeCalculationRule = (value?: string | null) => {
    if (!value) {
        return '';
    }

    return value
        .trim()
        .replace(/\s*([+-])\s*/g, ' $1 ')
        .replace(/\s+/g, ' ');
};

export const canonicalizeCalculationRule = (value?: string | null) => {
    const normalizedValue = normalizeCalculationRule(value);

    if (!normalizedValue) {
        return '';
    }

    const tokens = normalizedValue.split(' ');

    if (tokens[0] !== 'base_rate' || tokens.length % 2 === 0) {
        return normalizedValue;
    }

    const operands = new Map<string, string>();

    for (let i = 1; i < tokens.length; i += 2) {
        const operator = tokens[i];
        const operand = tokens[i + 1];

        if ((operator !== '+' && operator !== '-') || !operand || !calculationRuleOperands.includes(operand)) {
            return normalizedValue;
        }

        if (operands.has(operand)) {
            return normalizedValue;
        }

        operands.set(operand, operator);
    }

    const canonicalTokens = ['base_rate'];

    calculationRuleOperands.forEach((operand) => {
        const operator = operands.get(operand);

        if (operator) {
            canonicalTokens.push(operator, operand);
        }
    });

    return canonicalTokens.join(' ');
};

export const isSupportedCalculationRule = (value?: string | null) => {
    return calculationRuleValues.has(canonicalizeCalculationRule(value));
};
